import type { NextSeoProps } from 'next-seo/pages';

type Twitter = NonNullable<NextSeoProps['twitter']>;

type BuildTwitterObjectInput = {
	cardType?: string | null;
	handle?: string | null;
	site?: string | null;
};

export function buildTwitterObject(input: BuildTwitterObjectInput): Twitter {
	const { cardType, handle, site } = input;

	const twitterObject = { cardType: cardType || undefined, handle: handle || undefined, site: site || undefined };

	return twitterObject;
}
